import React                            from 'react';
import { Observe }                      from 'rewire-core';
import { Theme, WithStyle }             from 'rewire-ui';
import MainContentToolbar               from '../main-navigation/MainContentToolbar';
import Breadcrumbs                      from '../main-navigation/Breadcrumbs';
import ScheduleControls                 from '../schedule/ScheduleControls';
import scheduleControlsModel            from '../schedule/ScheduleControlsModel';
import PagingView                       from '../settings/PagingView';
import BatchSummaryControlsView         from './BatchSummaryControlsView';
import batchSummaryModel                from './BatchSummaryModel';
import DeleteIcon                       from '@material-ui/icons/Delete';
import OptionsActionMenu                from '../ui/OptionsActionMenu';
import { withStyles }                   from '../utility/styles';

const styles = (_theme: Theme) => ({
  left: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-start',
    flex: '0 1 auto',
    flexWrap: 'wrap',
  },
  right: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    flexWrap: 'wrap',
    flex: '0 1 auto',
  },
  pagingView: {
    padding: 0,
    height: 22,
    minHeight: 22,
    margin: '0px 0px 7px 20px',
    flex: '0 0 auto',
  },
  actionMenuButton: {
    minWidth: '0px',
    minHeight: '0px',
    padding: '0px',
    marginLeft: '15px',
    marginBottom: '7px',
  },
});

interface IBatchSummaryProps {
}

type BatchSummaryProps = WithStyle<ReturnType<typeof styles>, IBatchSummaryProps>;

class BatchSummaryToolbar extends React.PureComponent<BatchSummaryProps> {
  constructor(props: BatchSummaryProps) {
    super(props);
  }

  render() {
    const { classes } = this.props;

    return (
      <MainContentToolbar>
        <div className={classes.left}>
          <Breadcrumbs />
        </div>
        <div className={classes.right}>
          <div className={classes.left}>
            <BatchSummaryControlsView />
          </div>
          <div className={classes.right}>
            <Observe render={() => <PagingView paging={batchSummaryModel.pagingModel} className={classes.pagingView} hidePageCounts={!!scheduleControlsModel.scheduleGroupsPermitted.length} /> } />
            <ScheduleControls hideGroupBy={true} hideSortBy={true} hideActionMenu={true} />
            <OptionsActionMenu
                title='More Options'
                tooltip='More Options'
                classes={{menuButton: classes.actionMenuButton}}
                items={[{name: 'delete', title: 'Delete Batch', icon: DeleteIcon, onClick: batchSummaryModel.deleteBatch, disabled: () => !batchSummaryModel.canDelete, closeOnClick: true}]} />
          </div>
        </div>
      </MainContentToolbar>
    );
  }
}

export default withStyles<IBatchSummaryProps>(styles, BatchSummaryToolbar);
